import { render, staticRenderFns } from "./IndirectRequiredDetails.vue?vue&type=template&id=6fb16259"
import script from "./IndirectRequiredDetails.vue?vue&type=script&lang=js"
export * from "./IndirectRequiredDetails.vue?vue&type=script&lang=js"
import style0 from "./IndirectRequiredDetails.vue?vue&type=style&index=0&id=6fb16259&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports